/** @module csi/widget/_svg/Lock */
define([
	"dijit/form/Button",
	"csi/_base/underscore",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(Button,_,_Plugin,PluginFactory,util) {

	return PluginFactory.declare([Button, _Plugin], {
		materialIcon: "lock_outline",
		pluginName: "lock",
		title: "CanvasLockShape",

		/**
		 * Enable if there is at least one shape is selected
		 * @param {Shape[]} shapes
		 * @param {Object} shapeAttrs
		 * @param {Object} textAttrs
		 * @return {boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			return this.inherited(arguments) && shapes && shapes.length >= 1 && 
					!this.editor.isSubgroupSelected() && this.isAnyShapeUnlocked(shapes);
		},

		/**
		 * Return true if at least one shape is unlocked from shapes list
		 * @param  {_Shapes[]} shapes
		 * @returns {boolean}
		 */
		isAnyShapeUnlocked: function(shapes) {
			return _.some(shapes, function(shape) { return !util.isShapeLocked(shape); });
		},

		/**
		 * Invoke lock action
		 */
		onClick: function() {
			this.editor.lockShapes(true);
		}
	});
});
